"use client";

import { useEffect, useState } from "react";

export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.querySelector("[aria-labelledby='hero-heading']");
    if (!hero) return;

    const observer = new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), {
      threshold: 0,
    });

    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed right-0 bottom-0 left-0 z-50 border-t border-white/5 bg-[#030712]/80 px-4 py-3 backdrop-blur-xl lg:hidden">
      <a
        href="#contact"
        className="block w-full rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 py-3 text-center text-sm font-semibold text-white shadow-lg shadow-blue-500/25 transition-[box-shadow,filter,transform] active:scale-[0.98]"
      >
        Ontdek de mogelijkheden
      </a>
    </div>
  );
}
